/**
 * @class
 */
import Base from './attribute';

import {ids as attributeTypeIds} from '@netx/core-asset/properties/attributes';

export default class Attribute_Multiselect extends Base {
	/** @type {object} */
	get defaults() {
		return {
			...super.defaults,
			type: attributeTypeIds.multiselect,
		};
	}

	/** @type {boolean} */
	get isCSV() {
		return true;
	}

	/**
	 * @override
	 * @param {mixed} value Value
	 * @return {mixed} Parsed in value
	 */
	parseInValue(value) {
		// DAM-15267 - if there are no commas, one value, the regex in csvToArray()
		// will return null if the single value contains a single apostrophe
		if (_.isString(value) && value.indexOf(',') > -1) {
			value = _.csvToArray(value);
		}
		return super.parseInValue(value) || [];
	}

	/**
	 * @override
	 * @param {mixed} value Value
	 * @return {mixed} Parsed out value
	 */
	parseOutValue(value) {
		return super.parseOutValue(value) || [];
	}

	/** @type {string} */
	static get __name__() {
		return 'Attribute_Multiselect';
	}
}
